<template>
    <div class="container py-5">
        <h2>{{ $t('settings') }}</h2>
        <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="{ name: 'visualizations' }">
                            {{ $t('home') }}    
                        </router-link>
                    </li>
                    <li v-if="this.$route.name === 'datatables'" class="breadcrumb-item">
                        {{ $t('datatables') }}
                    </li>
                    <li v-else-if="this.$route.name === 'imagetables'" class="breadcrumb-item">
                        {{ $t('imagetables') }}
                    </li>
                    <li v-else-if="this.$route.name === 'layers'" class="breadcrumb-item">
                        {{ $t('layers') }}
                    </li>
                    <li v-else-if="this.$route.name === 'visualizations'" class="breadcrumb-item">
                        {{ $t('visualizations') }}
                    </li>
                    <li v-else-if="this.$route.name === 'groups'" class="breadcrumb-item">
                        {{ $t('groups') }}
                    </li>
                    <li v-else-if="this.$route.name === 'users'" class="breadcrumb-item">
                        {{ $t('users') }}
                    </li>
                </ol>
            </nav>
        <div class="row">   
            <div class="col-3">
                <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <router-link to="/settings/datatables" class="nav-link" active-class="nav-link active" id="datatables">
                        {{ $t('datatables') }}
                    </router-link>
                    <router-link to="/settings/imagetables" class="nav-link" active-class="nav-link active" id="imagetables">
                        {{ $t('imagetables') }}
                    </router-link>
                    <router-link to="/settings/layers" class="nav-link" active-class="nav-link active" id="layers">
                        {{ $t('layers') }}
                    </router-link>
                    <router-link to="/settings/visualizations" class="nav-link" active-class="nav-link active" id="visualizations">
                        {{ $t('visualizations') }}
                    </router-link>
                    <router-link to="/settings/groups" class="nav-link" active-class="nav-link active" id="groups">
                        {{ $t('groups') }}
                    </router-link>
                    <router-link to="/settings/users" class="nav-link" active-class="nav-link active" id="users">
                        {{ $t('users') }}
                    </router-link>
                </div>
            </div>
            <div class="col-9">
                <div class="tab-content" id="v-pills-tabContent">
                <router-view></router-view>
            </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {};
    }
};
</script>
